import {Assignment} from './assignment.model';

export class Review extends Assignment {
  reviewId: string;
  reviewStatusCode: string;
  commentText: string;
  specialityCode: string;
  nextCaseId: string;
  nextSpecialityCode: string;
}
